import React, { useEffect, useState } from 'react'

import { ClockContainer } from './styles'

const MINUTE = 60 * 1000

function pad(value: number): string {
  return String(value).padStart(2, '0')
}

/** ISO 8601 com o fuso local, para o `datetime` casar com o que está escrito na tela. */
function toLocalISO(date: Date): string {
  const offset = -date.getTimezoneOffset()
  const sign = offset >= 0 ? '+' : '-'
  const absolute = Math.abs(offset)

  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}` +
    `${sign}${pad(Math.floor(absolute / 60))}:${pad(absolute % 60)}`
  )
}

/**
 * Data e hora do relógio da máquina, sem consultar o servidor.
 *
 * O primeiro salto é agendado para o minuto cheio e só depois entra o intervalo de 60s — assim a
 * hora vira junto com o minuto, e não alguns segundos depois de a tela ter aberto.
 */
export const Clock: React.FC = () => {
  // Só passa a existir no cliente: renderizar a hora no servidor faria o texto divergir na
  // hidratação.
  const [now, setNow] = useState<Date | null>(null)

  useEffect(() => {
    setNow(new Date())

    let interval: ReturnType<typeof setInterval> | null = null

    const timeout = setTimeout(() => {
      setNow(new Date())
      interval = setInterval(() => setNow(new Date()), MINUTE)
    }, MINUTE - (Date.now() % MINUTE))

    return () => {
      clearTimeout(timeout)

      if (interval) {
        clearInterval(interval)
      }
    }
  }, [])

  if (!now) {
    return null
  }

  const date = `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${String(
    now.getFullYear()
  ).slice(-2)}`

  const time = `${pad(now.getHours())}:${pad(now.getMinutes())}`

  return (
    <ClockContainer>
      <time
        dateTime={toLocalISO(now)}
        aria-live="off"
        title="Data e hora atuais"
      >
        <span className="clock__date">{date}</span>
        <span className="clock__time">{time}</span>
      </time>
      <div className="clock__divider" />
    </ClockContainer>
  )
}
